import React from 'react';
import { Link } from '@material-ui/core';

import settings from '../../settings';

const Home = () => {
  return (
    <ul>
      <li>
        <Link href={settings.routes.BOARD_ANALYSIS}>Analysis Board</Link>
      </li>
      <li>
        <Link href={settings.routes.READER_BOARD_ANALYSIS}>Reader Analysis Board</Link>
      </li>
      <li>
        <Link href={settings.routes.BOARD_EDITOR}>Board Editor</Link>
      </li>
      <li>
        <Link href={settings.routes.BOARD_POSITION_ONLY_EDITOR}>Board Position Only Editor</Link>
      </li>
    </ul>
  )
}

export default Home;
